import { DashboardRule, Rule } from '@/optimizer';
import { convertDailyLimitToYearlyBudget } from '@/optimizer/helpers/convertDailyLimitToYearlyBudget';
import moment from 'moment';

const generateRulesForVariables = (
    variables: Record<string, number>,
    durationRatio: number,
) => {
    return Object.entries(variables).map(([key, value]) => {
        const yearlyBudget = Math.round(value / durationRatio);

        return {
            channel: key,
            type: 'Total budget',
            subtype: 'is exactly',
            value: yearlyBudget.toString(),
        };
    });
};

export const prepareRules = (
    variables: Record<string, number> | undefined,
    configRules: DashboardRule[],
    startDateArg: string,
    endDateArg: string,
): Rule[] => {
    const rules: Rule[] = [];
    const durationInDays = moment(endDateArg, 'DD-MM-YYYY').diff(
        moment(startDateArg, 'DD-MM-YYYY'),
        'days',
    ) + 1;
    const yearDays = 366;
    const durationRatio = durationInDays / yearDays;

    if (configRules.length > 0) {
        const dailyLimitRules = configRules.filter(
            (rule) => rule.type === 'Daily limit',
        );
        const convertedRules = convertDailyLimitToYearlyBudget(
            dailyLimitRules,
            startDateArg,
            endDateArg,
        );

        rules.push(
            ...configRules
                .filter((rule) => rule.type !== 'Daily limit')
                .map((rule) => ({
                    channel: rule.channel,
                    type: rule.type,
                    subtype: rule.subtype,
                    value: rule.value,
                })),
        );

        rules.push(...convertedRules);
    }

    if (variables) {
        const variableRules = generateRulesForVariables(
            variables,
            durationRatio,
        );
        rules.push(...variableRules);
    }
    return rules;
};
